import { render, staticRenderFns } from "./ScreeningIvrCallDetails.vue?vue&type=template&id=767c59c7&"
import script from "./ScreeningIvrCallDetails.vue?vue&type=script&lang=js&"
export * from "./ScreeningIvrCallDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningIvrCallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports